import {
	GET_AP_DASH_BW,
	GET_AP_DASH_BW_FAIL,
	GET_AP_DASH_BW_SUCCESS,
	GET_GROUP_DASH_BW,
	GET_GROUP_DASH_BW_FAIL,
	GET_GROUP_DASH_BW_SUCCESS,
	GET_HOME_DASH_BW,
	GET_HOME_DASH_BW_FAIL,
	GET_HOME_DASH_BW_SUCCESS,
} from '../../constants/graphConstants/dataBandwidthGraphConstants';

/**
 * Reducer function for managing home dashboard data Bandwidth Graph graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const homeDashBwReducer = (
	state = {
		loading: false,
		homeDashBwstats: {},
	},
	action
) => {
	switch (action.type) {
		case GET_HOME_DASH_BW:
			return {
				...state,
				loading: true,
			};
		case GET_HOME_DASH_BW_SUCCESS:
			return {
				...state,
				homeDashBwstats: action.payload,
				loading: false,
			};
		case GET_HOME_DASH_BW_FAIL:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};

/**
 * Reducer function for managing AP dashboard data Bandwidth Graph graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const apDashBwReducer = (
	state = {
		loading: false,
		apDashBwstats: {},
	},
	action
) => {
	switch (action.type) {
		case GET_AP_DASH_BW:
			return {
				...state,
				apDashBwstats : {},
				loading: true,
			};
		case GET_AP_DASH_BW_SUCCESS:
			return {
				...state,
				apDashBwstats: action.payload,
				loading: false,
			};
		case GET_AP_DASH_BW_FAIL:
			return {
				...state,
				apDashBwstats : {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};

/**
 * Reducer function for managing group dashboard data Bandwidth Graph graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const groupDashBwReducer = (
	state = {
		loading: false,
		groupDashBwstats: {},
	},
	action
) => {
	switch (action.type) {
		case GET_GROUP_DASH_BW:
			return {
				...state,
				groupDashBwstats : {},
				loading: true,
			};
		case GET_GROUP_DASH_BW_SUCCESS:
			return {
				...state,
				groupDashBwstats: action.payload,
				loading: false,
			};
		case GET_GROUP_DASH_BW_FAIL:
			return {
				...state,
				groupDashBwstats : {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};
